<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          :title="title"
          icon="account"
          class="authority-header" />
      <BaseBackButton
          :is-show="showBackButton"
          :return-destination="returnDestination" />
      <BaseDetailMoveData
          v-if="showDetailMoveDataComponent"
          :id="bdmdId"
          :title="bdmdTitle"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="sortedList"
          :path-parameter="pathParameter"
          :can-move-data="canMoveData"
          :router-path="routerPath" />
    </el-row>
    <el-row :gutter="40">
      <el-col :span="12"
          :class="colClass">
        <div class="edit-table-list">
          <div class="table-vertical">
            <div class="edit-button-wrap">
              <el-dropdown
                  v-show="showActionButton && (showEditButton || showDeleteButton)"
                  placement="bottom-start"
                  @command="actionCommand">
                <el-button size="small">
                  アクション
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu
                    slot="dropdown"
                    class="header-action-menu">
                  <el-dropdown-item
                      v-show="showEditButton"
                      :command="define.ROLE_MODE.EDIT"
                      :disabled="disableEditButton">
                    編集
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-show="showDeleteButton"
                      :command="define.ROLE_MODE.DELETE"
                      :disabled="disableDeleteButton">
                    削除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <BaseButton v-show="showCancelButton"
                  :disabled="disableCancelButton"
                  @click="cancel()">
                キャンセル
              </BaseButton>
              <BaseButton v-show="showSaveButton"
                  :disabled="disableSaveButton"
                  @click="save()">
                保存
              </BaseButton>
            </div>
            <slot name="list" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.permission-role-align-width {
  width: auto;
  min-width: 700px;
}
</style>

<script>

import { mapGetters, mapState } from 'vuex'
import * as define from '@/define'
import common from '@/utils/common'
import message from '@/utils/message'
import * as accountQuery from '@/queries/account'

import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import BaseBackButton from '@/components/molecules/BaseBackButton'
import BaseDetailMoveData from '@/components/molecules/BaseDetailMoveData'

export default {
  name: 'RoleDetail',
  components: {
    BaseButton,
    BaseHeader,
    BaseBackButton,
    BaseDetailMoveData
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    returnDestination: {
      type: String,
      default: ''
    },
    showBackButton: {
      type: Boolean,
      default: true
    },
    showActionButton: {
      type: Boolean,
      default: true
    },
    disableEditButton: {
      type: Boolean,
      default: true
    },
    disableDeleteButton: {
      type: Boolean,
      default: true
    },
    showSaveButton: {
      type: Boolean,
      default: true
    },
    disableSaveButton: {
      type: Boolean,
      default: false
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    disableCancelButton: {
      type: Boolean,
      default: false
    },
    bdmdId: {
      type: [String, Number],
      default: null
    },
    bdmdTitle: {
      type: String,
      default: null
    },
    pathParameter: {
      type: Array,
      default: () => {}
    },
    routerPath: {
      type: String,
      default: null
    },
    storePath: {
      type: String,
      default: null
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    showDeleteButton: {
      type: Boolean,
      default: false
    },
    isPermissionRole: {
      type: Boolean,
      default: false
    },
    sortedList: {
      type: Array,
      default: () => null
    },
    canMoveData: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state[this.storePath].listIndex,
      accountType: (state) => state.accountType
    }),
    ...mapGetters({
      isSystemAccount: 'isSystemAccount',
      getAccountTypePower: 'getAccountTypePower'
    }),
    showDetailMoveDataComponent () {
      return this.mode !== define.ROLE_MODE.NEW
    },
    mode () {
      return this.$store.state[this.storePath].mode
    },
    listIndex () {
      return this.$store.state[this.storePath].listIndex
    },
    size () {
      return this.$store.state[this.storePath].size
    },
    colClass () {
      return this.isPermissionRole ? 'permission-role-align-width' : ''
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.ROLE_MODE.EDIT:
          this.edit()
          break
        case define.ROLE_MODE.DELETE:
          this.delete()
          break
        default:
          break
      }
    },
    async edit () {
      if (!this.isSystemAccount()) {
        this.$loadingService.show()
        try {
          // 対象ロールを使用している自身の権限と同等以上のアカウントが存在する場合、編集不可
          const query = common.addGraphQlCondition(accountQuery.GRAPH_QL_QUERY_ACCOUNTS_USING_ROLE, { roleUuid: this.$route.params.id })
          const res = await common.postGraphQl(query)
          if (res.data.data.accountsUsingRole.length > 0) {
            let canEdit = true
            Object.keys(res.data.data.accountsUsingRole).some((key) => {
              if ((this.getAccountTypePower(res.data.data.accountsUsingRole[key].type) || 0) <= (this.getAccountTypePower(this.accountType) || 999) &&
               !(res.data.data.accountsUsingRole[key].type === 2 && this.accountType === 2)) {
                canEdit = false
                return true
              }
            })
            if (!canEdit) {
              this.$notify.error(message.MSG_523())
              return
            }
          }
        } catch (error) {
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }
      this.$emit('edit')
    },
    async delete () {
      if (!this.isSystemAccount()) {
        this.$loadingService.show()
        try {
          const query = common.addGraphQlCondition(accountQuery.GRAPH_QL_QUERY_ACCOUNTS_USING_ROLE, { roleUuid: this.$route.params.id })
          const res = await common.postGraphQl(query)

          // 対象ロールを使用しているアカウントが存在する場合、削除不可
          if (res.data.data.accountsUsingRole.length > 0) {
            this.$notify.error(message.MSG_524())
            return
          }
        } catch (error) {
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }

      this.$emit('delete')
    },
    save () {
      this.$emit('save')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/account/RoleDetail.vue